// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const QueryTreeIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="QueryTreeIcon" ref={forwardedRef} {...props}>
      <path d="M6.998 5.5a3 3 0 0 0 .908 2.15l-2.378 3.897A3 3 0 1 0 6.9 12.18l2.31-3.785a3 3 0 0 0 1.32.058l2.378 3.898a3 3 0 1 0 1.302-.745L11.9 7.82A3 3 0 1 0 6.998 5.5m1.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M4.998 16a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M15 16a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const QueryTreeIcon = /* @__PURE__ */ Object.assign(
  QueryTreeIconComponent,
  { displayName: 'QueryTreeIcon' },
);
